export const HAND_RAISED_AT_KEY = 'handRaisedAt';

export type RaisedHandParticipant = {
  identity: string;
  name?: string;
  attributes?: Record<string, string>;
};

export type RaisedHandEntry = {
  identity: string;
  name: string;
  raisedAt: number;
};

export const parseRaisedAt = (value: string | undefined): number | null => {
  if (!value) return null;
  const raisedAt = Number(value);
  if (!Number.isFinite(raisedAt) || raisedAt <= 0) return null;
  return raisedAt;
};

const displayName = (participant: RaisedHandParticipant): string => {
  const name = participant.name?.trim();
  return name || participant.identity;
};

export const rankRaisedHands = (
  participants: readonly RaisedHandParticipant[],
): RaisedHandEntry[] => {
  const queue = participants.flatMap((participant) => {
    const raisedAt = parseRaisedAt(participant.attributes?.[HAND_RAISED_AT_KEY]);
    if (raisedAt === null) return [];
    return [{ identity: participant.identity, name: displayName(participant), raisedAt }];
  });
  queue.sort(
    (left, right) => left.raisedAt - right.raisedAt || left.identity.localeCompare(right.identity),
  );
  return queue;
};

export const raisedHandRank = (
  queue: readonly RaisedHandEntry[],
  identity: string,
): number | null => {
  const index = queue.findIndex((entry) => entry.identity === identity);
  return index === -1 ? null : index + 1;
};

export function raisedHandsToNotify(
  previousIdentities: Iterable<string>,
  queue: readonly RaisedHandEntry[],
  localIdentity?: string,
): RaisedHandEntry[] {
  const seen = new Set(previousIdentities);
  return queue.filter(
    (entry) => !seen.has(entry.identity) && entry.identity !== localIdentity,
  );
}
